<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      <span>Copyright &copy;</span>
      <span>{{ new Date().getFullYear() }} </span>
      <b-link
        href="https://headhuntershq.com"
        target="_blank"
        rel="nofollow"
      >HeadHunters HQ</b-link>
      <span class="d-sm-inline-block">, All rights Reserved | </span>
      <b-link
        href="/terms"
        target="_blank"
        rel="nofollow"
      >
        Terms of Service</b-link>
      <span>, </span>
      <b-link
        href="/privacy-policy"
        target="_blank"
        rel="nofollow"
      >Privacy Policy</b-link>
    </span>

    <span
      class="float-md-right d-none d-md-block mr-5"
    >Made with
      <feather-icon
        icon="HeartIcon"
        size="21"
        class="text-danger stroke-current"
      />
    </span>
  </p>
</template>

<script>
import { BLink } from 'bootstrap-vue'

export default {
  components: {
    BLink,
  },
}
</script>
